/**
 * 埋点常量
 */

export default {
  pageView: 'pageView', // 页面浏览
  CB_mall_pageView: 'CB_mall_pageView', // CB创意商城页面浏览
  CB_mall_gotobuy: 'CB_mall_gotobuy', // 创意商城_立即购买
  CB_mall_next: 'CB_mall_next', // 下单流程_下一步
  CB_mall_gotoselectsupplier: 'CB_mall_gotoselectsupplier', // 下单流程_去选择供应商
  CB_mall_submitorder: 'CB_mall_submitorder', // 下单流程_提交订单
  works_home_videoview_click: 'works_home_videoview_click', // 作品库_主页_视频播放_点击
  works_course_videoview_click: 'works_course_videoview_click', // 作品库_新手教程_视频播放_点击
  // √点击视频模板_使用此模板
  clickVideoTemplateSuccess: 'clickVideoTemplateSuccess',
  // √点击图片模板使用此模板
  clickImageTemplateSuccess: 'clickImageTemplateSuccess',
  // √点击视频模板
  clickVideoTemplateCoverSuccess: 'clickVideoTemplateCoverSuccess',
  // √点击图片模板
  clickImageTemplateCoverSuccess: 'clickImageTemplateCoverSuccess',
  // √模板 / 案例列表全局筛选项任意点击，触发模板 / 案例列表排序方式任意点击，触发 模板 / 案例卡片任意点击，触发
  CB_activation1: 'CB_activation1',
  // √下载/分发点击
  CB_activation3: 'CB_activation3',
  // 触发素材点数扣费行为，触发
  CB_activation4: 'CB_activation4',
  // 完成微信/支付宝单次支付、会员套餐购买、素材币充值
  CB_revenue: 'CB_revenue',
  // PC端注册用户
  CB_PC_register_click_success: 'CB_PC_register_click_success',
  // 从活动页过来的注册用户
  CB_PC_from_edm_register_click_success: 'CB_PC_from_edm_register_click_success',
  // 领取14天试用期会员的用户, 首次领取
  VIP_for_free_click: 'VIP_for_free_click',
  // 优惠码兑换
  coupon_submit: 'coupon_submit',
  // 领取14天试用期会员的用户, 任务奖励第二次领取
  VIP_task_rewards_for_free_click: 'VIP_task_rewards_for_free_click',
  // 用户点击【使用此模板】按钮且成功打开编辑页面时上报，从作品库进入编辑页的也算
  edit_cz: 'edit_cz',
  // 用户点击【导出】且成功生成作品id时上报
  export_cz: 'export_cz',
  // 点击模板或案例时上报
  template_or_case_click_cz: 'template_or_case_click_cz',
  // 成功分发时上报
  distribute_cz: 'distribute_cz',
  // 搜索（模板列表）- 搜索方式、搜索关键词
  search_cz: 'search_cz',
  // 用户点击调用筛选时上报
  filter_cz: 'filter_cz',
  // 下载
  works_action_download_click: 'works_action_download_click',
  // 首页按钮曝光
  home_button_exposure_cz: 'home_button_exposure_cz',
  // 首页按钮点击
  home_button_click_cz: 'home_button_click_cz'
}
